module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "transferApply"
  }, [_c('div', {
    staticClass: "glodApply"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('span', [_vm._v(_vm._s(this.$t('home.transferApply')))])]), _vm._v(" "), _c('div', {
    staticClass: "applyForm"
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-form', {
    ref: "applyForm",
    attrs: {
      "model": _vm.applyForm,
      "label-width": "160px",
      "rules": _vm.applyRules
    }
  }, [_c('el-col', {
    class: {
      floatRightStyle: _vm.$i18n.locale === 'ae'
    },
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.holderName'),
      "prop": "login_holder"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('home.enterHolderName'),
      "disabled": ""
    },
    model: {
      value: (_vm.login_holder),
      callback: function($$v) {
        _vm.login_holder = $$v
      },
      expression: "login_holder"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.accountNumber'),
      "prop": "username"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('home.enterAccountNumber'),
      "disabled": ""
    },
    model: {
      value: (_vm.username),
      callback: function($$v) {
        _vm.username = $$v
      },
      expression: "username"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.rollinAccount'),
      "prop": "rollinAccount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('home.enterRollinAccount')
    },
    model: {
      value: (_vm.applyForm.rollinAccount),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "rollinAccount", $$v)
      },
      expression: "applyForm.rollinAccount"
    }
  })], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.transferAmount'),
      "prop": "amount"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('home.enterTransfer')
    },
    model: {
      value: (_vm.applyForm.amount),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "amount", $$v)
      },
      expression: "applyForm.amount"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.currency'),
      "prop": "currency"
    }
  }, [_c('el-select', {
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('home.selectCurrency')
    },
    model: {
      value: (_vm.applyForm.currency),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "currency", $$v)
      },
      expression: "applyForm.currency"
    }
  }, _vm._l((_vm.currencyOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.label
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": _vm.$t('home.comment'),
      "prop": "comment"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": _vm.$t('home.enterComment')
    },
    model: {
      value: (_vm.applyForm.comment),
      callback: function($$v) {
        _vm.$set(_vm.applyForm, "comment", $$v)
      },
      expression: "applyForm.comment"
    }
  })], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "applySubmit"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        return _vm.resetForm('applyForm')
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('home.reset')))]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.submitLoading
    },
    on: {
      "click": _vm.applySubmit
    }
  }, [_vm._v(_vm._s(_vm.$t('home.submit')))])], 1)], 1)])], 1), _vm._v(" "), _c('div', {
    staticClass: "applyInfo"
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [_c('div', {
    staticClass: "clearfix",
    attrs: {
      "slot": "header"
    },
    slot: "header"
  }, [_c('el-row', {
    attrs: {
      "gutter": 15
    }
  }, [_c('el-col', {
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    class: {
      floatRightStyle: _vm.$i18n.locale === 'ae'
    },
    attrs: {
      "span": 6
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('home.ApplicationInfo')))])]), _vm._v(" "), _c('el-col', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "span": 18
    }
  }, [_c('el-select', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "clearable": "",
      "placeholder": _vm.$t('home.selectAppStatus')
    },
    on: {
      "change": _vm.selectWithdraw
    },
    model: {
      value: (_vm.transferStatus),
      callback: function($$v) {
        _vm.transferStatus = $$v
      },
      expression: "transferStatus"
    }
  }, _vm._l((_vm.statusOptions), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.label,
        "value": item.value
      }
    })
  }), 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('div', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.applyTableLoading),
      expression: "applyTableLoading"
    }],
    staticClass: "applyTable"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.tableData,
      "stripe": "",
      "border": ""
    }
  }, _vm._l((_vm.tableHead), function(item, index) {
    return _c('el-table-column', {
      key: index,
      attrs: {
        "label": item.labelName,
        "prop": item.propName,
        "min-width": item.width,
        "show-overflow-tooltip": ""
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [(item.propName == 'STATUS') ? _c('span', [_c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (scope.row.STATUS === '0'),
              expression: "scope.row.STATUS === '0'"
            }]
          }, [_c('el-tag', {
            attrs: {
              "size": "small"
            }
          }, [_vm._v(_vm._s(_vm.$t('home.inHand')))])], 1), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (scope.row.STATUS === '1'),
              expression: "scope.row.STATUS === '1'"
            }]
          }, [_c('el-tag', {
            attrs: {
              "type": "success",
              "size": "small"
            }
          }, [_vm._v(_vm._s(_vm.$t('home.figureOut')))])], 1), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (scope.row.STATUS === '2'),
              expression: "scope.row.STATUS === '2'"
            }]
          }, [_c('el-tooltip', {
            staticClass: "item",
            attrs: {
              "effect": "dark",
              "content": scope.row.UPDATE_REASON ? scope.row.UPDATE_REASON : _vm.$t('other.noReason'),
              "placement": "top",
              "popper-class": "user-tooltip"
            }
          }, [_c('el-tag', {
            attrs: {
              "type": "danger",
              "size": "small"
            }
          }, [_vm._v(_vm._s(_vm.$t('home.rejected')))])], 1)], 1), _vm._v(" "), _c('span', {
            directives: [{
              name: "show",
              rawName: "v-show",
              value: (scope.row.STATUS === '3'),
              expression: "scope.row.STATUS === '3'"
            }]
          }, [_c('el-tag', {
            attrs: {
              "type": "warning",
              "size": "small"
            }
          }, [_vm._v(_vm._s(_vm.$t('home.canceled')))])], 1)]) : _c('span', [_vm._v(_vm._s(scope.row[item.propName]))])]
        }
      }], null, true)
    })
  }), 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "applyPage"
  }, [_c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-sizes": [10, 15, 20, 30, 50, 100, 200],
      "page-size": _vm.pageSize,
      "layout": "total, sizes, prev, pager, next, jumper",
      "total": _vm.total
    },
    on: {
      "size-change": _vm.handleSizeChange,
      "current-change": _vm.handleCurrentChange
    }
  })], 1)])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-490e6595","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/money/transferApply.vue
// module id = 1162
// module chunks = 1